export default __webpack_public_path__ + "static/media/swap.40fb8e49.svg";